"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var _default = exports["default"] = (0, _reactIntl.defineMessages)({
  srErrorsWarning: {
    id: 'components.SRErrors.srErrorsWarning',
    defaultMessage: 'Um ou mais erros no campo {name}'
  }
});